export enum TimeLineStepsEnum {
  NO_VALIDATED = 'no-validated',
  SUCCESS = 'success',
  FAILED = 'failed',
  RESERVATION = 'reservation'
}
